import api from './api';

const BASE = '/admin/config';

/**
 * Service pour la gestion admin des modules et paramètres de configuration
 */
class AdminConfigService {

  // ─── Stats ───────────────────────────────────────────────────────────────

  async getStats() {
    const { data } = await api.get(`${BASE}/stats`);
    return data;
  }

  // ─── Modules ─────────────────────────────────────────────────────────────

  async getModules(params = {}) {
    const { data } = await api.get(`${BASE}/modules`, { params });
    return data;
  }

  async getModule(id) {
    const { data } = await api.get(`${BASE}/modules/${id}`);
    return data;
  }

  async createModule(payload) {
    const { data } = await api.post(`${BASE}/modules`, payload);
    return data;
  }

  async updateModule(id, payload) {
    const { data } = await api.patch(`${BASE}/modules/${id}`, payload);
    return data;
  }

  async deleteModule(id) {
    const { data } = await api.delete(`${BASE}/modules/${id}`);
    return data;
  }

  // ─── Parameters ──────────────────────────────────────────────────────────

  async getParameters(params = {}) {
    const { data } = await api.get(`${BASE}/parameters`, { params });
    return data;
  }

  async getParameter(id) {
    const { data } = await api.get(`${BASE}/parameters/${id}`);
    return data;
  }

  async createParameter(payload) {
    const { data } = await api.post(`${BASE}/parameters`, payload);
    return data;
  }

  async updateParameter(id, payload) {
    const { data } = await api.patch(`${BASE}/parameters/${id}`, payload);
    return data;
  }

  async updateParameterValue(id, current_value) {
    const { data } = await api.patch(`${BASE}/parameters/${id}/value`, { current_value });
    return data;
  }

  async deleteParameter(id) {
    const { data } = await api.delete(`${BASE}/parameters/${id}`);
    return data;
  }
}

const adminConfigService = new AdminConfigService();
export default adminConfigService;
